// generated by genversion
export var version = '4.2.10';
//# sourceMappingURL=version.js.map